/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePathQuotaRequest
 */
export interface CreatePathQuotaRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePathQuotaRequest
     */
    forceDestroyContent?: boolean;
}

export function CreatePathQuotaRequestFromJSON(json: any): CreatePathQuotaRequest {
    return CreatePathQuotaRequestFromJSONTyped(json, false);
}

export function CreatePathQuotaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePathQuotaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'forceDestroyContent': !exists(json, 'force_destroy_content') ? undefined : json['force_destroy_content'],
    };
}

export function CreatePathQuotaRequestToJSON(value?: CreatePathQuotaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'force_destroy_content': value.forceDestroyContent,
    };
}


